import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Raven from 'raven-js';
import { chirpClient } from '../../clients/chirpClient';
import { getSettingsRpc } from '../../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/PublicPortalSettingsRpc';
import { Metrics } from '../../utils/Metrics';
import { ErrorActions } from '../../constants/ErrorActions';
import { RequestStatus } from '../../constants/RequestStatus';
const initialState = {
  data: null,
  requestStatus: RequestStatus.UNINITIALIZED,
  error: null
};
export const portalSettingsFetched = createAsyncThunk('publicPortalSettings/portalSettingsFetched', async () => {
  const startTime = performance.now();
  try {
    const response = await chirpClient.call(getSettingsRpc, {
      request: {}
    });
    Metrics.timer('portal-settings-fetch-duration').update(performance.now() - startTime);
    Metrics.counter('portal-settings-fetch-success').increment();
    return response;
  } catch (error) {
    Metrics.timer('portal-settings-fetch-duration').update(performance.now() - startTime);
    Metrics.counter('portal-settings-fetch-failure').increment();
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: {
        action: ErrorActions.PORTAL_SETTINGS_FETCHED
      }
    });
    throw error;
  }
});
const publicPortalSettingsSlice = createSlice({
  name: 'publicPortalSettings',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(portalSettingsFetched.pending, state => {
      state.requestStatus = RequestStatus.PENDING;
      state.error = null;
    }).addCase(portalSettingsFetched.rejected, (state, action) => {
      var _action$error$message, _action$error;
      state.requestStatus = RequestStatus.FAILED;
      state.error = (_action$error$message = (_action$error = action.error) === null || _action$error === void 0 ? void 0 : _action$error.message) !== null && _action$error$message !== void 0 ? _action$error$message : null;
    }).addCase(portalSettingsFetched.fulfilled, (state, action) => {
      state.requestStatus = RequestStatus.SUCCEEDED;
      state.data = action.payload;
    });
  }
});
export default publicPortalSettingsSlice.reducer;